import React, { useState, useMemo, useRef, memo } from 'react';
import { GetAllRoles, DeleteRole } from "../../../api/endpoints";
import AddEditRole from './CURole';
import ReportContent from '../../../components/tableDrawer/reportContent';
import ReportHeader from '../../../components/tableDrawer/reportHeader';
import DeleteBtn from '../../../components/tableDrawer/TableItems/components/tableActions/DeleteBtn';
import EditBtn from '../../../components/tableDrawer/TableItems/components/tableActions/EditBtn';
import ActionBtn from '@/components/ActionBtn';
import ScreenHeader from '@/components/ScreenHeader';

const RolesC = () => {

    const [RoleID, setRoleID] = useState(null);
    const [isInsertLookupLoaded, setIsInsertLookupLoaded] = useState(false);

    const insertModal = useRef("insertRoleModal")
    const updateModal = useRef("UpdateRoleModal")

    const columns = useMemo(() => [
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'nameEn',
            accessor: 'nameEN',
        },
        {
            id: 'action',
            Cell: ({ row: { original } }) =>
                <>
                    <DeleteBtn id={original.id} api={DeleteRole} />
                    <EditBtn id={original.id} onApply={updateRole} />
                </>
        }
    ], [])

    const updateRole = (roleID) => {
        setRoleID(roleID);
        updateModal.current.click()
    }

    const finishUpdate = () => {
        updateModal.current.click()
    }

    const handleOpenInsertModal = () => {
        insertModal.current.click()
        setIsInsertLookupLoaded(prev => true)
    }

    return (
        <>
            <ScreenHeader title="Role" >
                <div className='actions-container'>
                    <ActionBtn className='add-new-role' title="add-new-role" icon="mdi:plus" onApply={handleOpenInsertModal} />
                </div>
            </ScreenHeader>
            <AddEditRole modalID={insertModal} loadData={isInsertLookupLoaded} />
            <AddEditRole roleID={RoleID} modalID={updateModal} finishOperation={finishUpdate} />
            <ReportContent tableAPI={GetAllRoles} columns={columns}>
{/* <ReportHeader > <ReportSearch /> </ReportHeader> */}
            </ReportContent>
        </>
    );
}

export default memo(RolesC);